// apps/web/src/components/ui/Skeleton.tsx
// Shimmer placeholder block. Reduced-motion neutralizes the pulse (global guard).
export function Skeleton({ className = "" }: { className?: string }) {
  return <div aria-hidden="true" className={`animate-pulse bg-surface-strong rounded-xl ${className}`} />;
}

/** A few stacked skeleton rows, for list-style loading screens. */
export function ListSkeleton({ rows = 4 }: { rows?: number }) {
  return (
    <div className="space-y-2 pt-4">
      {Array.from({ length: rows }).map((_, i) => (
        <Skeleton key={i} className="h-14 rounded-2xl" />
      ))}
    </div>
  );
}
